import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EditablePage } from '@magnolia/react-editor';
import { useSelector, connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { getMagnoliaProps } from './magnolia.service';
import {componentMappings} from "./magnolia.config";
import NotFound from './pages/magnolia/notFound/NotFound';

const PageLoader = ({ currentLanguageCode }) => {
  const [magnoliaProps, setMagnoliaProps] = useState(null);
  const location = useLocation();
  const siteData = useSelector((state) => state.siteData);

  useEffect(() => {
    const loadPage = async () => {
        const props = await getMagnoliaProps(location, siteData, currentLanguageCode);
        setMagnoliaProps(props);
    };

    loadPage();
  }, [currentLanguageCode, location]);

  if (!magnoliaProps) {
    return (
      <div className="flone-preloader-wrapper">
        <div className="flone-preloader">
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  if (magnoliaProps.content && magnoliaProps.content['@nodeType'] === 'mgnl:page') {
    return (
        <EditablePage
            content={{...magnoliaProps.content, navigationContent: magnoliaProps.navigationContent}}
            config={{ componentMappings }}
            templateAnnotations={magnoliaProps.templateAnnotations}
            magnoliaContext={magnoliaProps.magnoliaContext}
        />
    );
  }

  return <NotFound />;
};

export default connect()(multilanguage(PageLoader));